import axios from 'axios';
import { getToken } from './auth';

const API_URL = process.env.REACT_APP_API_URL || 'https://backend.chamafruits.com';

const withAuth = () => ({
  headers: { Authorization: `Bearer ${getToken()}` },
  withCredentials: true,
});

export const registerClient = async (data) => (await axios.post(`${API_URL}/client`, data, withAuth())).data;
export const getClients = async (params = {}) =>
  (await axios.get(`${API_URL}/client`, { ...withAuth(), params })).data;
export const getClientsSummary = async (params = {}) =>
  (await axios.get(`${API_URL}/client/summaries`, { ...withAuth(), params })).data;
export const getClientById = async (id) => (await axios.get(`${API_URL}/client/${id}`, withAuth())).data;
export const getClientsByRut = async (rut) => (await axios.get(`${API_URL}/client/rut`, { ...withAuth(), params: { rut } })).data;
export const updateClient = async (id, data) => (await axios.patch(`${API_URL}/client/${id}`, data, withAuth())).data;

export const getClientPricingDiscounts = async (id, params = {}) =>
  (await axios.get(`${API_URL}/client/${id}/pricing-discounts`, { ...withAuth(), params })).data;

export const getClientCustomPricingDiscountCatalog = async (params = {}) =>
  (await axios.get(`${API_URL}/client/pricing-discount-catalog`, { ...withAuth(), params })).data;

export const getClientPurchaseOrderCategories = async (id) =>
  (await axios.get(`${API_URL}/client/${id}/purchase-order-categories`, withAuth())).data;

export const updateClientPurchaseOrderCategories = async (id, categoryIds = []) =>
  (await axios.put(`${API_URL}/client/${id}/purchase-order-categories`, { categoryIds }, withAuth())).data;

export const enableClientPortalAccount = async (clientId) =>
  (await axios.post(`${API_URL}/client-auth/enable-account`, { clientId }, withAuth())).data;

export const resendClientPortalPassword = async (clientId) =>
  (await axios.post(`${API_URL}/client-auth/reset-password`, { clientId }, withAuth())).data;

export const disableClientPortalAccount = async (clientId) =>
  (await axios.post(`${API_URL}/client-auth/disable-account`, { clientId }, withAuth())).data;

export const getClientSummary = async (id, params = {}) =>
  (await axios.get(`${API_URL}/client/${id}/summary`, { ...withAuth(), params })).data;
export const getClientOpenPurchases = async (id, params = {}) =>
  (await axios.get(`${API_URL}/client/${id}/open-purchases`, { ...withAuth(), params })).data;
export const getClientPayments = async (id, params = {}) =>
  (await axios.get(`${API_URL}/client/${id}/payments`, { ...withAuth(), params })).data;

export const createClientPayment = async (id, data) =>
  (await axios.post(`${API_URL}/client/${id}/payments`, data, withAuth())).data;
export const updateClientPayment = async (id, paymentId, data) =>
  (await axios.patch(`${API_URL}/client/${id}/payments/${paymentId}`, data, withAuth())).data;
export const deleteClientPayment = async (id, paymentId) =>
  (await axios.delete(`${API_URL}/client/${id}/payments/${paymentId}`, withAuth())).data;

export const resetClientCreditGrace = async (id) =>
  (await axios.patch(`${API_URL}/client/${id}/credit-grace/reset`, {}, withAuth())).data;
